import { ENavGroups, ERoutes, IRoute } from "./types";

const routes: IRoute[] = [
	// ERoutes.Club
	{
		id: ERoutes.Club,
		title: 'ロータリークラブとは',
		description: "クラブ概要",
		navGroups: [
			{
				id: ENavGroups.Club,
				title: 'クラブ概要'
			}
		],
		breadcrumbs: [
			{ label: 'クラブ概要' }
		]
	},
	// ERoutes.Club
	{
		id: ERoutes.Club,
		parent: ERoutes.Club,
		title: 'ロータリークラブとは',
		description: "クラブ概要",
		breadcrumbs: [
			{ label: 'クラブ概要' },
		],
		nav: {
			exact: true,
			label: 'クラブ概要',
			groupId: ENavGroups.Club,
			link: '/club'
		}
	},
	// ERoutes.Outline
	{
		id: ERoutes.Outline,
		parent: ERoutes.Club,
		title: '東京中央ロータリークラブについて',
		description: "クラブ概要",
		breadcrumbs: [
			{ label: 'クラブ概要', path: '/club' },
			{ label: '東京中央ロータリークラブについて' },
		],
		nav: {
			label: '東京中央ロータリークラブについて',
			groupId: ENavGroups.Club,
			link: '/club/outline'
		}
	},
	// ERoutes.Committee
	{
		id: ERoutes.Committee,
		parent: ERoutes.Club,
		title: '委員会',
		description: "クラブ概要",
		breadcrumbs: [
			{ label: 'クラブ概要', path: '/club' },
			{ label: '委員会' },
		],
		nav: {
			label: '委員会一覧',
			groupId: ENavGroups.Club,
			link: '/club/committee'
		}
	},
	// ERoutes.Association
	{
		id: ERoutes.Association,
		parent: ERoutes.Club,
		title: '同好会',
		description: "クラブ概要",
		breadcrumbs: [
			{ label: 'クラブ概要', path: '/club' },
			{ label: '同好会' },
		],
		nav: {
			label: '同好会一覧',
			groupId: ENavGroups.Club,
			link: '/club/association'
		}
	},
	// ERoutes.RotaryGlossary
	{
		id: ERoutes.RotaryGlossary,
		parent: ERoutes.Club,
		title: 'ロータリー用語辞典',
		description: "クラブ概要",
		breadcrumbs: [
			{ label: 'クラブ概要', path: '/club' },
			{ label: 'ロータリー用語辞典' },
		],
		nav: {
			label: 'ロータリー用語辞典',
			groupId: ENavGroups.Club,
			link: '/club/dictionary'
		}
	},
	// ERoutes.Volunteer
	{
		id: ERoutes.Volunteer,
		title: '奉仕活動',
		subtitle: "Volunteer",
		navGroups: [
			{
				id: ENavGroups.Social,
				title: '社会奉仕'
			},
			{
				id: ENavGroups.International,
				title: '国際奉仕'
			}
		],
		breadcrumbs: [
			{ label: '奉仕活動' }
		]
	},
	// ERoutes.Ishinomaki
	{
		id: ERoutes.Ishinomaki,
		parent: ERoutes.Volunteer,
		title: "石巻市にガラス絵寄贈",
		description: '奉仕活動',
		breadcrumbs: [
			{ label: '奉仕活動', path: '/volunteer' },
			{ label: '石巻市にガラス絵寄贈' },
		],
		nav: {
			label: '石巻市にガラス絵寄贈',
			groupId: ENavGroups.Social,
			link: '/volunteer/activities/ishinomaki'
		}
	},
	// ERoutes.Dvd
	{
		id: ERoutes.Dvd,
		parent: ERoutes.Volunteer,
		title: "視覚障害者支援DVD",
		description: '奉仕活動',
		breadcrumbs: [
			{ label: '奉仕活動', path: '/volunteer' },
			{ label: '視覚障害者支援DVD' },
		],
		nav: {
			label: '視覚障害者支援DVD',
			groupId: ENavGroups.Social,
			link: '/volunteer/activities/dvd'
		}
	},
	// ERoutes.Uminomori
	{
		id: ERoutes.Uminomori,
		parent: ERoutes.Volunteer,
		title: "海の森公園に参加",
		description: '奉仕活動',
		breadcrumbs: [
			{ label: '奉仕活動', path: '/volunteer' },
			{ label: '海の森公園に参加' },
		],
		nav: {
			label: '海の森公園に参加',
			groupId: ENavGroups.Social,
			link: '/volunteer/activities/uminomori'
		}
	},
	// ERoutes.Gairojyu
	{
		id: ERoutes.Gairojyu,
		parent: ERoutes.Volunteer,
		title: "街の街路樹植栽事業に参加",
		description: '奉仕活動',
		breadcrumbs: [
			{ label: '奉仕活動', path: '/volunteer' },
			{ label: '街の街路樹植栽事業に参加' },
		],
		nav: {
			label: '街の街路樹植栽事業に参加',
			groupId: ENavGroups.Social,
			link: '/volunteer/activities/gairojyu'
		}
	},
	// ERoutes.Dental
	{
		id: ERoutes.Dental,
		parent: ERoutes.Volunteer,
		title: "デンタルミッションボランティア",
		description: '奉仕活動',
		breadcrumbs: [
			{ label: '奉仕活動', path: '/volunteer' },
			{ label: 'デンタルミッションボランティア' },
		],
		nav: {
			label: 'デンタルミッションボランティア',
			groupId: ENavGroups.International,
			link: '/volunteer/activities/dental'
		}
	},
	// ERoutes.Myanmar
	{
		id: ERoutes.Myanmar,
		parent: ERoutes.Volunteer,
		title: "ミャンマーに小学校を贈る",
		description: '奉仕活動',
		breadcrumbs: [
			{ label: '奉仕活動', path: '/volunteer' },
			{ label: 'ミャンマーに小学校を贈る' },
		],
		nav: {
			label: 'ミャンマーに小学校を贈る',
			groupId: ENavGroups.International,
			link: '/volunteer/activities/myanmar'
		}
	},
	// ERoutes.Member
	{
		id: ERoutes.Member,
		title: '会員募集',
		subtitle: 'Member',
		breadcrumbs: [
			{ label: '会員募集' }
		]
	},
	// ERoutes.Speeches
	{
		id: ERoutes.Speeches,
		title: '卓話ライブラリー',
		subtitle: 'Speech Library',
		breadcrumbs: [
			{ label: '卓話ライブラリー' }
		]
	},
	// ERoutes.Makeup
	{
		id: ERoutes.Makeup,
		title: 'メークアップ',
		subtitle: "Make Up",
		navGroups: [
			{
				id: ENavGroups.MakeUp,
				title: 'メークアップ'
			}
		],
		breadcrumbs: [
			{ label: 'メークアップ' }
		]
	},
	// ERoutes.OneZone
	{
		id: ERoutes.OneZone,
		parent: ERoutes.Makeup,
		title: "第1ゾーン",
		description: 'メークアップ',
		breadcrumbs: [
			{ label: 'メークアップ', path: '/makeup' },
			{ label: '第1ゾーン' },
		],
		nav: {
			label: '第一ゾーン',
			groupId: ENavGroups.MakeUp,
			link: '/makeup/1zone'
		}
	},
	// ERoutes.TwoZone
	{
		id: ERoutes.TwoZone,
		parent: ERoutes.Makeup,
		title: "第2ゾーン",
		description: 'メークアップ',
		breadcrumbs: [
			{ label: 'メークアップ', path: '/makeup' },
			{ label: '第2ゾーン' },
		],
		nav: {
			label: '第二ゾーン',
			groupId: ENavGroups.MakeUp,
			link: '/makeup/2zone'
		}
	},
	// ERoutes.ThreeZone
	{
		id: ERoutes.ThreeZone,
		parent: ERoutes.Makeup,
		title: "第3ゾーン",
		description: 'メークアップ',
		breadcrumbs: [
			{ label: 'メークアップ', path: '/makeup' },
			{ label: '第3ゾーン' },
		],
		nav: {
			label: '第三ゾーン',
			groupId: ENavGroups.MakeUp,
			link: '/makeup/3zone'
		}
	},
]

export { routes }